<template>
	<base-popup-dialog v-model="value" :maxBodyWidth="450" :maxBodyHeight="500" :title="local_title">
	<div slot="dialogBody">
		<v-container>						
			<v-row no-gutters>
				<v-col >
				<v-text-field 
				label="Web URL added to the image" 
				ref="url"  v-model="local_item.url" 
				dense outlined required 
				:error="urlError" 
				:error-messages="urlErrorLabel"
				></v-text-field>
				</v-col>
			</v-row>			
			
			<v-row no-gutters>
				<v-col>
				<v-text-field label="Title" 
				ref="title" 
				v-model="local_item.title" 
				dense 
				outlined 
				required 
				:error="titleError" 
				:error-messages="titleErrorLabel"
				counter="40"
				maxlength="40"
				></v-text-field>
				</v-col>			
				<v-col cols="0" md="0" class="ml-5 pr-2">				
					<v-tooltip  color="white black--text" top>
						<template v-slot:activator="{ on, attrs }">
							<span v-on="on" v-bind="attrs">
							<color-picker-panel
								:items="colors"
								:value="getTitleColor"
								@change="setTitleColor"
							></color-picker-panel>
							</span>
						</template>
						<div>{{title_font_color}}</div>
					</v-tooltip>
				</v-col>
			</v-row>

			<v-row no-gutters>	
				<v-col>
					<v-textarea  label="Description" 
					ref="desc" 
					v-model="local_item.desc" 
					dense 
					outlined 
					required 
					:error="descError" 
					:error-messages="descErrorLable"
					counter="580"
					:rules="[v => (v || '' ).length <= 580 || 'Description must be 580 characters or less']"
					></v-textarea>
				</v-col>
					<v-col cols="0" md="0" class="ml-5 pr-2">				
					<v-tooltip color="white black--text" top>
						<template v-slot:activator="{ on,attrs }">
							<span v-on="on" v-bind="attrs">
								<color-picker-panel
									:items="colors"
									:value="getDescriptionColor"
									@change="setDescriptionColor"
								></color-picker-panel>
							</span>
						</template>
						<div>{{description_font_color}}</div>
					</v-tooltip>					
				</v-col>
			</v-row>

			<v-row no-gutters>
				<v-col>
				<v-text-field label="Button Link"
				v-model="local_item.learnmore.link" 
				dense outlined required 
				:error="learnmoreLinkError" 
				:error-messages="linkErrorLabel"
				></v-text-field>							
				</v-col>
			</v-row>						
			<v-row no-gutters>
				<v-col >
				<v-text-field label="Button Caption"
				v-model="local_item.learnmore.caption" dense outlined required 
				:error="learnmoreCaptionError" 
				:error-messages="captionErrorLabel"
				></v-text-field>
				</v-col>
				<v-col cols="0" md="0" class="ml-5 pr-2">
					<v-tooltip color="white black--text" top>
						<template v-slot:activator="{ on, attrs }">
							<span v-on="on" v-bind="attrs">
							<color-picker-panel
								:items="captionButtonColors"
								:value="getCaptionColor"
								@change="setCaptionColor"
							></color-picker-panel>
							</span>
						</template>
						<div>{{button_caption_font_color}}</div>
					</v-tooltip>
				</v-col>							
			</v-row>
			
			<v-row no-gutters>
				<v-col>
					<v-menu
						ref="menu"
						v-model="menu"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						min-width="290px"
					>
					<template v-slot:activator="{ on, attrs }">
					<v-text-field
						v-model="dateFormatted"
						label="Set Showcase Expiry Date"
						append-icon="event"
						outlined
						dense
						v-bind="attrs"
						v-on="on"					
						ref="expiryDate"
						@blur="validateSelectedDate(dateFormatted)"
						v-on:click:append="menu=true"						
						:error="expiryDateError" :error-messages="expiryDateErrorLabel"
					></v-text-field>
					</template>
					<v-date-picker 
					v-model="local_item_expiryDate" 
					@click:date="formatSelectedDate(local_item_expiryDate)"
					no-title
					:min="currentDate"							
					@input="menu = false"></v-date-picker>
					</v-menu>
				</v-col>
			</v-row>						
		</v-container>
	</div>

	<div slot="dialogFooter">
		<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="applyChanges(local_title)">Apply</v-btn>
					<v-btn text color="primary" v-if="!local_isLastShowcase && this.local_title == 'Update Showcase'" @click="removeShowcase(local_item)">Delete</v-btn>
					<v-btn text color="primary" @click="onCloseDlg">Cancel</v-btn>
				</v-card-actions>
	</div>
	</base-popup-dialog>	
</template>

<script>

import BasePopUpDialog from "@/dialogs/base-popup-dialog.vue";
import ColorPickerPanel from "@/dialogs/color-picker-panel.vue"
export default {

	name: "carousel-dailog-box",   
	props: ["value", "item", "title", "userType", "isLastShowcase"],
	components: {
		"base-popup-dialog": BasePopUpDialog,
		"color-picker-panel": ColorPickerPanel
	},
	data() {	
		return{		
			title_font_color: 'Title font color',
			description_font_color: 'Description font color',
			button_caption_font_color: 'Button caption font color',
			local_isLastShowcase: this.isLastShowcase,
			local_userType: this.userType,
			local_title: this.title,
			local_item: {
				id: this.item.id,
				name: this.item.name,
				url: this.item.url,
				title: this.item.title,
				local_titlecolor: this.item.titlecolor,
				desc: this.item.description,
				local_desccolor: this.item.descriptioncolor,
				learnmore:{
					link: this.item.captionurl,
					caption: this.item.captionname,
					color: this.item.captioncolor
				},
				expireDateFormatByCP: this.item.expireDateFormatByCP
			},
			// local_item_expiryDate: this.item.expire,
			local_item_expiryDate: this.item.copyOfExpire,
			colors: ['black', 'white', '#261E4D', '#73BEC1', '#BADB82', '#E1363C', '#FE6743', '#ABABAB'],
			captionButtonColors: ['black', 'white', 'blue', '#73BEC1', 'green', '#E1363C', '#FE6743', '#ABABAB'],
			isFileUploaded: false,
			isDataUpdated: false,
			isDataAdded: false,
			file: '',
			fileError: false,
			urlError: false,
			titleError: false,
			descError: false,
			learnmoreLinkError: false,
			learnmoreCaptionError: false,
			learnmoreColorError: false,
			expiryDateError: false,			
			urlErrorLabel: "",
			titleErrorLabel: "",
			descErrorLable: "",
			linkErrorLabel: "",
			captionErrorLabel: "",
			expiryDateErrorLabel: "",
			menu: false,
			delete_dlg: false,
			delete_item: null,
			showcaseAction_dlg: false,
			showcaseActionMessage: null,
			actionFlag: false,
			currentDate: new Date().toISOString().slice(0,10),
			textboxExpiryDate: '',
			istextboxExpiryDate: false,
			isExpiryDateSet: false,
			expireDateToSet: '',
			expireDateToReturn: '',
			previousSetDate: '',
			isSelectedDateValid: false,
			dateFormatted: "",
			invalidDateErrorMessage: "Invalid URL/Invalid date format. Please enter the date in the format \"mm/dd/yyyy\", or Enter future date",
			invalidInputFieldLength: "Please verify the input information are valid and not exceeded length existed"
		}
	},

	computed: {		
		getCaptionColor(){
			let buttonCaptionColorToReturn = "";
			if(typeof this.local_item.learnmore.color == "undefined" || null == this.local_item.learnmore.color){
				buttonCaptionColorToReturn = this.captionButtonColors[2];
			}else{
				this.captionButtonColors.forEach((color, index) => {
					if(color == this.local_item.learnmore.color){
						buttonCaptionColorToReturn = this.captionButtonColors[index];
					}
				});
				if(this.local_item.learnmore.color == "blue lighten-1" || this.local_item.learnmore.color == "#261E4D"){
					buttonCaptionColorToReturn = this.captionButtonColors[2];
				}else if(this.local_item.learnmore.color == "#BADB82"){
					buttonCaptionColorToReturn = this.captionButtonColors[4];
				}else if(this.local_item.learnmore.color == "red"){
					buttonCaptionColorToReturn = this.captionButtonColors[5];
				}else if(buttonCaptionColorToReturn.length == 0){
					buttonCaptionColorToReturn = this.captionButtonColors[2];
				}
				
			}	
			this.setCaptionColor(buttonCaptionColorToReturn);				
			console.log("button caption color: "+buttonCaptionColorToReturn);
			return buttonCaptionColorToReturn;	
		},

		getTitleColor(){
			let titleColorToReturn = "";			
			if(typeof this.local_item.local_titlecolor == 'undefined' || null == this.local_item.local_titlecolor){
				titleColorToReturn = this.colors[1];
			}
			else{
				this.colors.forEach((color, index) => {
					if(color == this.local_item.local_titlecolor){
						titleColorToReturn = this.colors[index];
					}
				});
			}
			if(titleColorToReturn.length == 0){
					titleColorToReturn = this.colors[1];
			}
			this.setTitleColor(titleColorToReturn);
			console.log("title color: "+titleColorToReturn);
			return titleColorToReturn;
		},
		
		getDescriptionColor(){
			let descriptionColorToSet = "";
			if(typeof this.local_item.local_desccolor == 'undefined' || null == this.local_item.local_desccolor){
				descriptionColorToSet = this.colors[1];
			}else{
				this.colors.forEach((color, index) => {
					if(color == this.local_item.local_desccolor){
						descriptionColorToSet = this.colors[index];
					}
				});		
			}
			if(descriptionColorToSet.length == 0){
					descriptionColorToSet = this.colors[1];
			}
			this.setDescriptionColor(descriptionColorToSet);
			console.log("desc color: "+descriptionColorToSet);
			return descriptionColorToSet;
		}
	},
	
	created(){
		console.log("inside created() method.");
		console.log("this.item.copyOfExpire: "+this.item.copyOfExpire);
		if(this.item.copyOfExpire){
			this.dateFormatted = this.item.copyOfExpire;
			this.local_item_expiryDate =  new Date(Date.parse(this.dateFormatted)).toJSON(); 
			console.log("this.dateFormatted: "+this.dateFormatted);
			this.emitChange();
		}
	},
	methods: {
		formatSelectedDate(date){
			console.log("selected date: "+date);
			this.dateFormatted = this.formatDate(date);
			this.emitChange();
		},
		emitChange(){
            this.$emit("input",this.dateFormatted)
        },		
		validateSelectedDate(){
			console.log("inside validateSelectedDate: "+this.$refs.expiryDate.lazyValue);
			const textFieldValue = this.$refs.expiryDate.lazyValue;
			if(this.$refs.expiryDate.lazyValue != ""){
				try{					
					console.log(textFieldValue);
					const convertedDate = new Date(Date.parse(textFieldValue, 'MM/dd/yyyy'));
					console.log(convertedDate);
					if(convertedDate == "Invalid Date"){
						console.log("this.local_item.expireDateFormatByCP: "+this.local_item.expireDateFormatByCP);
						const convertedDatePerCP = new Date(Date.parse(this.local_item.expireDateFormatByCP, 'MM/dd/yyyy'));
						if(convertedDatePerCP == "Invalid Date"){
							this.isSelectedDateValid = false;						
							this.$refs.expiryDate.lazyValue = "";
						}else{
							this.dateFormatted = this.local_item.expireDateFormatByCP;
							this.isSelectedDateValid = true;
						}
					}else{							
						this.dateFormatted = textFieldValue;
						this.isSelectedDateValid = true;
					}
				}catch(error){
					console.log(error)
					this.isSelectedDateValid = false;					
				}
			}else{
				this.dateFormatted = textFieldValue;
				this.isSelectedDateValid = true;
			}						
		},
		formatDate(date) {				
            if (!date) {
				return null;
			}
			if (date.indexOf('T') != -1){
              date = date.split('T')[0];
			}			
            const [year, month, day] = date.split('-')
            return `${month}/${day}/${year}`;
		},
		setCaptionColor(captionColor){
			console.log(captionColor);
			this.local_item.learnmore.color = captionColor;
		},	
		
		setTitleColor(titleColor){
			console.log(titleColor);
			this.local_item.local_titlecolor = titleColor;
		},

		setDescriptionColor(descriptionColor){
			console.log(descriptionColor);
			this.local_item.local_desccolor = descriptionColor;
		},

		async uploadImageFromUrl(){			
				const response = await this.$store.dispatch("uploadImageFromUrl",this.local_item.url);
				console.log(response);//changed response.data
				if(response.status == "success"){
					this.isFileUploaded= true;
					console.log("isFileUploaded: ",this.isFileUploaded);
				}else{
					this.alertActionMessage("File is NOT uploaded successfully", false);
				}			
		},
		async applyChanges(action){
			console.log("inside applyChanges() method");
			if(action == "Add Showcase"){
				const addResponse = await this.addShowcase();
				console.log("Add Showcase response: "+addResponse);
			}else{
				const updateResponse = await this.updateShowcase();
				console.log("Update Showcase response: "+updateResponse);
			}
		},
		removeShowcase(item){
			const confirmObject = {}
            confirmObject.showDlg= true;
            confirmObject.buttons={
                OKButton:{
                    Caption:"OK"
                },
                CancelButton:{
                    Caption:"Cancel"
                }
            };
            confirmObject.title="Warning";
            confirmObject.type="Info";   
            confirmObject.message="Please Confirm to delete Showcase '"+item.title+"'";
            confirmObject.submitCallback =  () =>{
				this.goToDelete(item);
				}
            confirmObject.cancelCallback =  () =>{
				this.closeDeleteDailogBox(false);
				}
            this.$store.dispatch("setConfirmDialogDetails",confirmObject);
			},

			goToDelete(item){
            console.log("goToDelete(), removing showcases details, item: "+item)                
                this.$store.dispatch("removeShowcase", {entity:item,callbackFunc:()=>{
						this.$emit("input", false);
						this.$emit("closeCarouselDailogBox");
					}, failurecallbackFunc:()=>{	
						const confirmObject = {}
						confirmObject.showDlg= true;
						confirmObject.buttons={
						CloseButton:{
							Caption:"Close"
						}
						}
						confirmObject.title="Error";
						confirmObject.type="Error";
						confirmObject.message="Error occurred while removing showcase: '"+item.title+"'";
						this.$store.dispatch("setConfirmDialogDetails",confirmObject);
					}});
			},
			closeDeleteDailogBox(){
				this.onCloseDlg();
			},
		
		async addShowcase(){
			console.log("inside addShowcase() method. UserType: "+this.userType+" and this.file.size: "+this.file.size);
			const isValidDetails = await this.validateInputDetails();
			if(isValidDetails){
				await this.validateSelectedDate();
			}
			console.log("isValidDetails && isSelectedDateValid: "+(isValidDetails && this.isSelectedDateValid));
			if(isValidDetails && this.isSelectedDateValid){
					const addShowcase = {};
					addShowcase.id = this.local_item.id;
					addShowcase.url = this.local_item.url;
					addShowcase.title = this.local_item.title;
					addShowcase.titlecolor = this.local_item.local_titlecolor == null ? 
						this.setColorToReturn(this.getTitleColor) : 
						this.setColorToReturn(this.local_item.local_titlecolor);
					addShowcase.description = this.local_item.desc;
					addShowcase.descriptioncolor = this.local_item.local_desccolor == null ? 
						this.setColorToReturn(this.getDescriptionColor) : 
						this.setColorToReturn(this.local_item.local_desccolor);
					addShowcase.captionurl = this.local_item.learnmore.link;
					addShowcase.captionname = this.local_item.learnmore.caption;
					addShowcase.captioncolor = this.local_item.learnmore.color;
					this.expireDateToSet = this.getExpireDateToSet();
					console.log("expireDateToSet: "+this.expireDateToSet);
					console.log("addShowcaseData: "+addShowcase);
					const response = await this.$store.dispatch("addShowcaseDetails",{entity:addShowcase, expire: this.expireDateToSet,callbackFunc:()=>{
							this.$emit("closeCarouselDailogBox");
					}, failurecallbackFunc:()=>{				
						this.validateSelectedDate();
						const confirmObject = {}
						confirmObject.showDlg= true;
						confirmObject.buttons={
						CloseButton:{
							Caption:"Close"
						}
						}
						confirmObject.title="Error";
						confirmObject.type="Error";
						confirmObject.message=this.invalidInputFieldLength;
						this.$store.dispatch("setConfirmDialogDetails",confirmObject);
					}});
					console.log(response);					
			}
		},

		setColorToReturn(colorToSet){
			let returningColor = '';
			this.colors.forEach((color) => {
				if(color == colorToSet){
					returningColor = color;
				}
			});
			return returningColor;
		},

		getExpireDateToSet(){
			console.log(this.$refs.expiryDate);
			this.expireDateToReturn = this.$refs.expiryDate.lazyValue;
			console.log("reference value: "+this.expireDateToReturn)
			if(this.expireDateToReturn == ""){
				this.expireDateToReturn = "NoExpiry";
			}else{
				console.log("time: "+new Date().getHours()+" "+new Date().getMinutes()+" "+new Date().getSeconds());
				this.expireDateToReturn = this.expireDateToReturn + " "+new Date().getHours()+":"+new Date().getMinutes()+":"+new Date().getSeconds();
			}
			return this.expireDateToReturn;
		},
		async validateInputDetails(){
			console.log("inside validateInputDetails() method");
			if( this.local_item.url === "" || typeof this.local_item.url == "undefined"){
				this.urlError = true;
				this.urlErrorLabel = "Do not leave url field blank or undefined";
			}else{
				this.urlError = false;
				this.urlErrorLabel = null;
			}
			if( this.local_item.title ==="" || typeof this.local_item.title == "undefined"){
				this.titleError = true;
				this.titleErrorLabel = "Do not leave Title field blank";
			}else {				
				this.titleError = false;
				this.titleErrorLabel = null;
			}
			if(this.local_item.desc == "" || typeof this.local_item.desc == "undefined"){
				this.descError = true;
				this.descErrorLable = "Do not leave Description field blank";
			}else{ 				
				this.descError = false;
				this.descErrorLable = null;
			}
			if(this.local_item.learnmore.color == "" || typeof this.local_item.learnmore.color == "undefined"){
				this.local_item.learnmore.color=this.captionButtonColors[2];
				console.log(this.local_item.learnmore.color);
			}else{ 				
				this.learnmoreColorError = false;
			}
			if(this.local_item.learnmore.caption == "" || typeof this.local_item.learnmore.caption == "undefined"){
				this.learnmoreCaptionError = true;
				this.captionErrorLabel="Do not leave caption blank";
			}else{ 				
				this.learnmoreCaptionError = false;
				this.captionErrorLabel = null;
			}
			if(this.local_item.learnmore.link == "" || typeof this.local_item.learnmore.link == "undefined"){
				this.learnmoreLinkError = true;
				this.linkErrorLabel = "Do not leave Link field blank";
			}else{
				this.learnmoreLinkError = false;
				this.linkErrorLabel = null;
			}
			if(this.local_item_expiryDate == "" || typeof this.local_item_expiryDate == "undefined"){
				this.local_item.expiryError = true;
				this.local_item.expiryErrorLabel = "Do not leave expiry date field blank";
			}else{ 				
				this.local_item.expiryError = false;
				this.local_item.expiryErrorLabel = null;				
			}

			if(!this.urlError && !this.learnmoreLinkError){
				await this.$store.dispatch("validateFileUrl", {entity:this.local_item.url,callbackFunc:()=>{				
                this.urlError = false;
				this.urlErrorLabel = null;
			}, failurecallbackFunc:()=>{
                this.urlError = true;
				this.urlErrorLabel = "Please enter valid URL.";
			}});
				await this.$store.dispatch("validateFileUrl",{entity:this.local_item.learnmore.link,callbackFunc:()=>{
                this.learnmoreLinkError = false;
				this.linkErrorLabel = null;
            }, failurecallbackFunc:()=>{
				this.learnmoreLinkError = true;
				this.linkErrorLabel = "Please enter valid server address.";
			}});			
		}
			const isDataValid = (!this.urlError && !this.titleError && !this.descError 
			&&  !this.learnmoreLinkError && !this.learnmoreCaptionError 
			&& !this.learnmoreColorError && !this.local_item.expiryDateError);
			console.log("isDataValid: "+isDataValid);
			return isDataValid;
		},
		async updateShowcase(){	
			console.log("inside updateShowcase() method.");
			const isValidDetails = await this.validateInputDetails();
			if(isValidDetails){
				await this.validateSelectedDate();
			}
			console.log("isValidDetails && isSelectedDateValid: "+(isValidDetails && this.isSelectedDateValid));
			if(isValidDetails && this.isSelectedDateValid){
					const updateShowcase = {};
					updateShowcase.id = this.local_item.id;
					updateShowcase.url = this.local_item.url;
					updateShowcase.title = this.local_item.title;
					updateShowcase.titlecolor = this.local_item.local_titlecolor == null ? 
						this.setColorToReturn(this.getTitleColor) : 
						this.setColorToReturn(this.local_item.local_titlecolor);
					updateShowcase.description = this.local_item.desc;
					updateShowcase.descriptioncolor = this.local_item.local_desccolor == null ?
						this.setColorToReturn(this.getDescriptionColor) : 
						this.setColorToReturn(this.local_item.local_desccolor);
					updateShowcase.captionurl = this.local_item.learnmore.link;
					updateShowcase.captionname = this.local_item.learnmore.caption;
					updateShowcase.captioncolor = this.local_item.learnmore.color;
					this.expireDateToSet = this.getExpireDateToSet();
					console.log("expireDateToSet: "+this.expireDateToSet);
					console.log(updateShowcase);
					const response = await this.$store.dispatch("updateShowcaseDetails",{entity:updateShowcase, expire:this.expireDateToSet,callbackFunc:()=>{				
							this.$emit("closeCarouselDailogBox");
					}, failurecallbackFunc:()=>{				
						this.validateSelectedDate();
						const confirmObject = {}
						confirmObject.showDlg= true;
						confirmObject.buttons={
						CloseButton:{
							Caption:"Close"
						}
						}
						confirmObject.title="Error";
						confirmObject.type="Error";
						confirmObject.message=this.invalidInputFieldLength;
						console.log("from updateShowcaseDetails");
						this.$store.dispatch("setConfirmDialogDetails",confirmObject);						
					}});
					console.log(response);//changed response.data
				return response;
			}else{
				console.log("field error");
				return null;
			}		
		},
		isObject(o) {
            return o !== null && typeof o === 'object' && Array.isArray(o) === false;
		},			
		onCloseDlg() {
			// this.local_show_dlg = false;
			this.$emit("closeCarouselDailogBox");
		},
		closeShowcaseActionDailogBox(){
			this.showcaseAction_dlg= false;
			this.showcaseActionMessage = null;
			if(this.actionFlag){
				this.onCloseDlg();
			}
		},
		alertActionMessage(message, flag){
			this.showcaseAction_dlg= true;
			this.showcaseActionMessage = message;
			this.actionFlag = flag;
		}
		
	}
}
</script>

<style>
 .v-dialog .v-dialog-card .v-card__text{
	padding-bottom: 20px;
	padding-left: 10px;
	padding-right: 10px;
}
</style>>	
	